import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import classnames from "classnames";
import { MD } from "constants/sizes";
import AssetComponent from "components/core/asset/asset-component";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { titleFontSizeNumber, titleLineHeights } from "segments/desktop/core-components/title/consts";
import { StyledHoverableCards } from "./hoverable-card.scss";

const REM_TO_PX = 16;

const DEFAULT_PARAGRAPH = {
  topic: {}
};

const HoverableCard = ({
  defaultColor,
  asset,
  hoveredAsset,
  paragraph,
  hoveredColor,
  onHover,
  isSelected,
  setCardsMaxHeight,
  textResizeConfig,
  fullParagraphAdvancedConfig: { selectedTitleSize, titleSize = MD, ...paragraphConfig }
}) => {
  const ref = useRef(null);
  const [paragraphHeight, setParagraphHeight] = useState(null);
  const titleSizeInPx = useMemo(() => titleFontSizeNumber[titleSize] * REM_TO_PX, [titleSize]);
  const titleLineHeight = useMemo(() => titleLineHeights[titleSize]?.replace("px", ""), [titleSize]);

  const setContentHeights = useCallback(() => {
    if (!ref.current) return;

    const cardParagraphHeight = ref.current.querySelector(".paragraph-body").getBoundingClientRect().height;
    setParagraphHeight(`${cardParagraphHeight}px`);
    const cardHeight = ref.current.getBoundingClientRect().height;
    setCardsMaxHeight(isSelected ? cardHeight : cardHeight + cardParagraphHeight);
  }, [setCardsMaxHeight]);

  useEffect(() => {
    setContentHeights();

    window.addEventListener("resize", setContentHeights);
    return () => window.removeEventListener("resize", setContentHeights);
  }, [setContentHeights]);

  return (
    <StyledHoverableCards
      ref={ref}
      textResizeConfig={textResizeConfig}
      titleSize={titleSizeInPx}
      defaultColor={defaultColor}
      onMouseEnter={onHover}
      titleLineHeight={titleLineHeight}
      hoveredColor={hoveredColor}
      paragraphHeight={paragraphHeight}
      className={classnames("hoverable-card", { selected: isSelected })}
    >
      <div className="asset-container">
        <div className="default-asset">
          <AssetComponent onImageLoad={setContentHeights} {...asset} />
        </div>
        <div className="selected-asset">
          <AssetComponent {...hoveredAsset} />
        </div>
      </div>
      <FullParagraph
        {...DEFAULT_PARAGRAPH}
        {...paragraph}
        {...paragraphConfig}
        titleSize={selectedTitleSize}
        titleClassName="card-title"
      />
    </StyledHoverableCards>
  );
};

export default HoverableCard;
